/* @flow */
/**
 * External dependencies
 */
import styled, { injectGlobal } from 'styled-components';

/**
 * Internal dependencies
 */
import { initialState as theme } from '../reducers/theme';

/**
 * Style
 */
injectGlobal`
	body {
		background-color: #000;
		color: ${ theme.color };
		font-family: 'Source Sans Pro', sans-serif;
		-moz-osx-font-smoothing: grayscale;
		-webkit-font-smoothing: antialiased;
		line-height: 1.25;
		min-height: 100vh;
	}

	button {
		color: inherit;
	}
`;

export const clearfix = styled.div`
	&::before,
	&::after {
		content: "";
		display: table;
	}

	&::after {
		clear: both;
	}
`;



// WEBPACK FOOTER //
// ./src/style/global.js